<script setup lang="ts">
import { ref, onMounted, onUnmounted } from "vue"
import FilterWizardDesktop from "./filter-wizard-desktop.vue"
import FilterWizardMobile from "./filter-wizard-mobile.vue"

const props = defineProps<{
  searchProps: {
    q: string[];
    currentUrl: string;
    subJobType?: string;
  };
  frontendFacets: FacetType;
  sortKeys: string[];
}>();

const isMobile = ref(false)

const updateScreenSize = () => {
  isMobile.value = window.innerWidth < 768 // Bootstrap lg breakpoint
}

onMounted(() => {
  updateScreenSize()
  window.addEventListener('resize', updateScreenSize)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateScreenSize)
})
</script>

<template lang="pug">
FilterWizardMobile(
  v-if="isMobile"
  :searchProps="searchProps"
  :frontendFacets="frontendFacets"
  :sortKeys="sortKeys"
)
FilterWizardDesktop(
  v-else
  :searchProps="searchProps"
  :frontendFacets="frontendFacets"
  :sortKeys="sortKeys"
)
</template>
